<template>
  <div
    class="app-main-content"
    style="position:relative;"
  >
    <ie-detail-workspace
      ref="bookingWorkspace"
      :parent-context="context"
      :open-multiple="true"
      @back="backToList"
    />
  </div>
</template>

<script>
import { IeBookingContext } from '@/views/cargo/v0/Integrated/ieBookingContext'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { advancedQuery } from '@/api/integratedJob/ieBooking'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { cache } from '@/utils/cacheManager'
import lodash from 'lodash'
import ieDetailWorkspace from './ieWorkspace'

export default {
  name: 'DestinationBusinessIeDetail',
  components: { ieDetailWorkspace },
  data() {
    return {
      context: new IeBookingContext(),
      loading: null
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  async created() {
    await this.context.prepareData()
    // 加载UICustom配置，确保与源业务类型详情页配置一致
    if (Number(cache.hqConfig.get('UICustomization')) === 1) {
      const branchId = this.$store.getters.currentOfficeId
      await UICustomUtil.loadUICustomPageInfo('/DestinationBusiness/IeDetail', branchId)
    }
  },
  async mounted() {
    const jobNo = this.$route.query.key
    const branchId = this.$route.params.branchId || this.$store.getters.currentOfficeId
    if (!jobNo) {
      this.$message.error(this.$t('Message.JumpFailed'))
      return
    }
    const loading = getLoading4Cxt(this)
    try {
      const filter = {
        conditions: [
          new AdvancedSearchOption(null, 'job.JOB_NO', jobNo, 'LIKE').formatObj2Json()
        ],
        branchId,
        pageNum: 1
      }
      const res = await advancedQuery(filter)
      let rowData = res.data.list || []
      if (rowData.length === 0) {
        this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
        return
      }
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new IntegratedJob(item).fillDefaultValue()
        item.version = 0
      }
      // 从store获取列表页当前页数据，用于左侧业务编号列表展示
      const storeJobs = this.$store.state.destinationBusiness.currentPageJobs || []
      if (storeJobs.length > 0) {
        // 过滤出IE类型的业务数据
        const ieJobs = storeJobs.filter(job => job.lob === 'IE')
        if (ieJobs.length > 0) {
          const mergedData = []
          const apiJobMap = new Map(rowData.map(j => [j.jobNo, j]))
          for (const job of ieJobs) {
            const apiJob = apiJobMap.get(job.jobNo)
            mergedData.push(apiJob || job)
          }
          rowData = lodash.cloneDeep(mergedData)
          for (const item of rowData) {
            new IntegratedJob(item).fillDefaultValue()
            item.version = 0
          }
        }
      }
      const selectedRow = rowData.find(p => p.jobNo === jobNo) || rowData[0]
      let action = 'look'
      if (this.$route.params.action) {
        action = this.$route.params.action
        delete this.$route.params.action
      }
      this.$refs.bookingWorkspace.onShow(action, rowData, selectedRow)
    } catch (err) {
      this.$message.error(this.$t('Message.JumpFailed'))
      throw err
    } finally {
      loading.close()
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    backToList() {
      const targetPath = this.$route.query.menuType === 'overseaTracking'
        ? '/DestinationBusiness/OverseaTracking'
        : '/DestinationBusiness/EndCommerce'
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.push({ path: targetPath })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
